// Component.vue (style omitted)
<template>
	<div class="container">
		<center>
			<h1><strong>Terima Kasih!</strong></h1>
			<span>Jazakumullah khoiron katsiron, semoga Allah Ta’ala memberikan keberkahan kepada para donatur atas donasi yang diberikan.</span>
		</center>
			<button class='bg-yellow-500 mt-4 py-1.5 rounded-md shadow-md text-lg w-full uppercase font-bold text-white focus:outline-none focus:bg-yellow-600' @click="$emit('close-toast')">aamiin</button>
	</div>
</template>